export default "__VITE_ASSET__UBOYBrPZ__"